module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Down-2-f01f4a8921ec8946fd5d67203b6cf551.svg";